import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ReportServiceApi } from "../../services";
import * as jobConstants from "../../enums/jobs";
const initialState = {
  // reportStartDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
  reportStartDate: new Date(new Date().setDate(new Date().getDate() - 2)),
  // reportEndDate: new Date(),
  reportEndDate: new Date(new Date().setDate(new Date().getDate() - 1)),
  filterChannelType: [],
  filterDocType: 0,
  tabViewType: 0,
  filterReportType: 1,
  loading: false,
  slaReportList: [],
  slaDownloadReportList: {},
  slaMetBreachDownloadReportList: {},
  customReportList: [],
  customBusinessTypeReportList: {},
  customPackMetrisReportList: {},
  customPackVolumnReportList: {},
  currentReportList: [],
  currentCommsReportList: {},
  currentRPCReportList: {},
  detailsReportList: [],
  childJobDeailList: [],
  detailsDownloadReportList: [],
  expandedReportDetailRows: {},

  totalRecords: 0,
  page: 1,
  size: jobConstants.ROWS_PER_PAGE,
  basicFirst: 0,
  basicRows: jobConstants.ROWS_PER_PAGE,
  filterDetailsKeyword: "",
}

// For get all sla report
export const fetchSlaReportData = createAsyncThunk('jobs/fetchSlaReportData', async (req) => {
  return ReportServiceApi.fetchUserSlaReport(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});

// for downaload sla metrics report
export const fetchSlaDownloadReportData = createAsyncThunk('jobs/fetchSlaDownloadReportData', async (req) => {
  return ReportServiceApi.fetchSlaDownloadReport(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});


// for downaload sla met & breach report
export const fetchSlaMetBreachDownloadReportData = createAsyncThunk('jobs/fetchSlaMetBreachDownloadReportData', async (req) => {
  return ReportServiceApi.fetchMetBreachDownloadReport(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});


// For get all custom report
export const fetchCustomReportData = createAsyncThunk('jobs/fetchCustomReportData', async (req) => {
  return ReportServiceApi.fetchUserCustomReport(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});

// for downaload business type report
export const fetchCustomBusinessTypeDownloadReportData = createAsyncThunk('jobs/fetchCustomBusinessTypeDownloadReportData', async (req) => {
  return ReportServiceApi.fetchUserCustomBusinessTypeDownloadReport(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});


// for downaload pack metrics report
export const fetchCustomPackMetricsDownloadReportData = createAsyncThunk('jobs/fetchCustomPackMetricsDownloadReportData', async (req) => {
  return ReportServiceApi.fetchUserCustomPackMetricsDownloadReport(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});


// for downaload pack volumn report
export const fetchCustomPackVolumnDownloadReportData = createAsyncThunk('jobs/fetchCustomPackVolumnDownloadReportData', async (req) => {
  return ReportServiceApi.fetchUserCustomPackVolumnDownloadReport(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});

// For get all current report
export const fetchCurrentReportData = createAsyncThunk('jobs/fetchCurrentReportData', async (req) => {
  return ReportServiceApi.fetchUserCurrentReport(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});

// for downaload current comms report
export const fetchCurrentCommsDownloadReportData = createAsyncThunk('jobs/fetchCurrentCommsDownloadReportData', async (req) => {
  return ReportServiceApi.fetchUserCurrentCommsDownloadReport(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});

// for downaload current rpc report
export const fetchCurrentRPCDownloadReportData = createAsyncThunk('jobs/fetchCurrentRPCDownloadReportData', async (req) => {
  return ReportServiceApi.fetchUserCurrentRPCDownloadReport(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});

// For get all details report
export const fetchDetailsReportData = createAsyncThunk('jobs/fetchDetailsReportData', async (req) => {
  return ReportServiceApi.fetchUserDetailsReport(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});

export const fetchReportDetailsChildJobs = createAsyncThunk('jobs/fetchReportDetailsChildJobs', async (req) => {
  return ReportServiceApi.fetchUserReportDetailsChildJobs(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});

export const fetchDetailsDownloadReportData = createAsyncThunk('jobs/fetchDetailsDownloadReportData', async (req) => {
  return ReportServiceApi.fetchUserDetailsDownloadReport(req).then(response => {
    console.log("thunk res", response?.data)
    return response?.data;
  });
});

const reportSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setReportStartDate: (state, action) => {
      state.reportStartDate = action.payload;
    },
    setReportEndDate: (state, action) => {
      state.reportEndDate = action.payload;
    },
    setFilterChannelType: (state, action) => {
      state.filterChannelType = action.payload;
    },
    setFilterDocType: (state, action) => {
      state.filterDocType = action.payload;
    },
    setFilterReportType: (state, action) => {
      state.filterReportType = action.payload;
    },
    setTabViewType: (state, action) => {
      state.tabViewType = action.payload;
    },
    setExpandedReportDetailRows: (state, action) => {
      state.expandedReportDetailRows = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSize: (state, action) => {
      state.size = action.payload;
    },
    setBasicFirst: (state, action) => {
      state.basicFirst = action.payload;
    },
    setBasicRows: (state, action) => {
      state.basicRows = action.payload;
    },
    setFilterDetailsKeyword: (state, action) => {
      state.filterDetailsKeyword = action.payload;
    },
  },
  extraReducers: builder => {
    // For get all sla report start
    builder.addCase(fetchSlaReportData.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchSlaReportData.fulfilled, (state, action) => {
      console.log("redux res fetchSlaReportData", action.payload);
      state.loading = false;
      state.slaReportList = action?.payload?.data ? action?.payload?.data : [];
      state.error = '';
    });

    builder.addCase(fetchSlaReportData.rejected, (state, action) => {
      state.loading = false;
      state.slaReportList = [];
      state.error = action.error.message;
    });
    // For get all sla report end


    // For sla download report start
    builder.addCase(fetchSlaDownloadReportData.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchSlaDownloadReportData.fulfilled, (state, action) => {

      console.log("redux res fetchSlaDownloadReportData", action.payload);
      state.loading = false;
      state.slaDownloadReportList = action?.payload?.data ? action?.payload?.data : {};
      state.error = '';
    });

    builder.addCase(fetchSlaDownloadReportData.rejected, (state, action) => {
      state.loading = false;
      state.slaDownloadReportList = {};
      state.error = action.error.message;
    });


    builder.addCase(fetchSlaMetBreachDownloadReportData.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchSlaMetBreachDownloadReportData.fulfilled, (state, action) => {

      console.log("redux res fetchMetBreachDownloadReportData", action.payload);
      state.loading = false;
      state.slaMetBreachDownloadReportList = action?.payload?.data ? action?.payload?.data : [];
      state.error = '';
    });

    builder.addCase(fetchSlaMetBreachDownloadReportData.rejected, (state, action) => {
      state.loading = false;
      state.slaMetBreachDownloadReportList = {};
      state.error = action.error.message;
    });
    // For sla download report end

    // For get all custom report start
    builder.addCase(fetchCustomReportData.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchCustomReportData.fulfilled, (state, action) => {
      console.log("redux res fetchCustomReportData", action.payload);
      state.loading = false;
      state.customReportList = action?.payload?.data ? action?.payload?.data : [];
      state.error = '';
    });

    builder.addCase(fetchCustomReportData.rejected, (state, action) => {
      state.loading = false;
      state.customReportList = [];
      state.error = action.error.message;
    });


    // For get all custom business type download report start
    builder.addCase(fetchCustomBusinessTypeDownloadReportData.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchCustomBusinessTypeDownloadReportData.fulfilled, (state, action) => {
      console.log("redux res fetchCustomBusinessTypeDownloadReportData", action.payload);
      state.loading = false;
      state.customBusinessTypeReportList = action?.payload?.data ? action?.payload?.data : {};
      state.error = '';
    });

    builder.addCase(fetchCustomBusinessTypeDownloadReportData.rejected, (state, action) => {
      state.loading = false;
      state.customBusinessTypeReportList = {};
      state.error = action.error.message;
    });


    // For get all custom pack metrics download report start
    builder.addCase(fetchCustomPackMetricsDownloadReportData.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchCustomPackMetricsDownloadReportData.fulfilled, (state, action) => {
      console.log("redux res fetchCustomPackMetricsDownloadReportData", action.payload);
      state.loading = false;
      state.customPackMetrisReportList = action?.payload?.data ? action?.payload?.data : {};
      state.error = '';
    });

    builder.addCase(fetchCustomPackMetricsDownloadReportData.rejected, (state, action) => {
      state.loading = false;
      state.customPackMetrisReportList = {};
      state.error = action.error.message;
    });


    // For get all custom pack volumn download report start
    builder.addCase(fetchCustomPackVolumnDownloadReportData.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchCustomPackVolumnDownloadReportData.fulfilled, (state, action) => {
      console.log("redux res fetchCustomPackVolumnDownloadReportData", action.payload);
      state.loading = false;
      state.customPackVolumnReportList = action?.payload?.data ? action?.payload?.data : {};
      state.error = '';
    });

    builder.addCase(fetchCustomPackVolumnDownloadReportData.rejected, (state, action) => {
      state.loading = false;
      state.customPackVolumnReportList = {};
      state.error = action.error.message;
    });



    // For get all custom report end

    // For get all current report start
    builder.addCase(fetchCurrentReportData.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchCurrentReportData.fulfilled, (state, action) => {
      console.log("redux res fetchCurrentReportData", action.payload);
      state.loading = false;
      state.currentReportList = action?.payload?.data ? action?.payload?.data : [];
      state.error = '';
    });

    builder.addCase(fetchCurrentReportData.rejected, (state, action) => {
      state.loading = false;
      state.currentReportList = [];
      state.error = action.error.message;
    });


    // For get all current comms download report start
    builder.addCase(fetchCurrentCommsDownloadReportData.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchCurrentCommsDownloadReportData.fulfilled, (state, action) => {
      console.log("redux res fetchCurrentCommsDownloadReportData", action.payload);
      state.loading = false;
      state.currentCommsReportList = action?.payload?.data ? action?.payload?.data : {};
      state.error = '';
    });

    builder.addCase(fetchCurrentCommsDownloadReportData.rejected, (state, action) => {
      state.loading = false;
      state.currentCommsReportList = {};
      state.error = action.error.message;
    });
    // For get all current comms download report end


    // For get all current rpc download report start
    builder.addCase(fetchCurrentRPCDownloadReportData.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchCurrentRPCDownloadReportData.fulfilled, (state, action) => {
      console.log("redux res fetchCurrentRPCDownloadReportData", action.payload);
      state.loading = false;
      state.currentRPCReportList = action?.payload?.data ? action?.payload?.data : {};
      state.error = '';
    });

    builder.addCase(fetchCurrentRPCDownloadReportData.rejected, (state, action) => {
      state.loading = false;
      state.currentRPCReportList = {};
      state.error = action.error.message;
    });
    // For get all current rpc download report end


    // For get all details report start
    builder.addCase(fetchDetailsReportData.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchDetailsReportData.fulfilled, (state, action) => {
      console.log("redux res fetchDetailsReportData", action.payload);
      state.loading = false;
      state.detailsReportList = action?.payload?.data?.list;
      state.totalRecords = action?.payload?.data?.totalItems;
      state.error = '';
    });

    builder.addCase(fetchDetailsReportData.rejected, (state, action) => {
      state.loading = false;
      state.detailsReportList = [];
      state.error = action.error.message;
      state.totalRecords = 0;
    });


    builder.addCase(fetchReportDetailsChildJobs.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchReportDetailsChildJobs.fulfilled, (state, action) => {
      console.log("redux res fetchReportDetailsChildJobs", action.payload);
      state.loading = false;
      state.childJobDeailList = action?.payload?.data;
      state.error = '';
    });

    builder.addCase(fetchReportDetailsChildJobs.rejected, (state, action) => {
      state.loading = false;
      state.childJobDeailList = [];
      state.error = action.error.message;
    });


    builder.addCase(fetchDetailsDownloadReportData.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchDetailsDownloadReportData.fulfilled, (state, action) => {
      console.log("redux res fetchDetailsDownloadReportData", action.payload);
      state.loading = false;
      state.detailsDownloadReportList = action?.payload?.data;
      state.error = '';
    });

    builder.addCase(fetchDetailsDownloadReportData.rejected, (state, action) => {
      state.loading = false;
      state.detailsDownloadReportList = [];
      state.error = action.error.message;
    });
    // For get all details report end

  }
})

export default reportSlice.reducer;
export const {
  setReportStartDate,
  setReportEndDate,
  setFilterChannelType,
  setFilterDocType,
  setFilterReportType,
  setTabViewType,
  setExpandedReportDetailRows,
  setPage,
  setSize,
  setBasicFirst,
  setBasicRows,
  setFilterDetailsKeyword,
} = reportSlice.actions;